<p class="control-title"><strong>Entity/FSS</strong></p>
<ui-dropdown-simple
    [keyName]="'name'"
    [valueName]="'employeeFunctionId'"
    [optionsList]="functionsFullList"
    [selectedValue]="selectedValue"
    [placeholder]="'Select'"
    [showListOnTop]="true"
    [disabled]="disabled()"
    (valueChange)="onSelectionChange($event)">
</ui-dropdown-simple>
